@if (form) {
  <div class="pb-4" [formGroup]="form">
    <div class="row row-gap-4" formGroupName="user">
      <div class="col-12">
        <h3 class="m-0 font-16 fw-bold text-black pe-4 pb-2 border-2 border-bottom d-flex w-max">
          {{ "FRIENDS_OF_OMAN_MUSEUM.PERSONAL_DETAILS" | translate }}
        </h3>
      </div>

      <!-- nameEn -->
      <div class="col-sm-6 col-lg-4">
        <app-input-text label="USER.NAME_EN" formControlName="nameEn" [readonly]="readonly()" />
      </div>

      <!-- nameAr -->
      <div class="col-sm-6 col-lg-4">
        <app-input-text label="USER.NAME_AR" formControlName="nameAr" [readonly]="readonly() && form.get('user')?.get('nameAr')?.value" />
      </div>

      <!-- userName -->
      <div class="col-sm-6 col-lg-4">
        <app-input-text label="FIELDS.USERNAME" formControlName="userName" [readonly]="readonly()" />
      </div>

      @if (readonly()) {
        <!-- dateOfBirth -->
        <div class="col-sm-6 col-lg-4">
          <app-datepicker label="FIELDS.DATE_OF_BIRTH" formControlName="dateOfBirth" [maxDate]="birthDateMaxDate" />
        </div>
      }

      <!-- email -->
      <div class="col-sm-6 col-lg-4">
        <app-input-text label="FIELDS.EMAIL" formControlName="email" contentType="email" [readonly]="readonly()" />
      </div>

      <!-- phone -->
      <div class="col-sm-6 col-lg-4">
        <app-input-text-dropdown
          label="FIELDS.PHONE"
          formControlName="phone"
          dropdownFormControlName="countryCode"
          bindValue="phoneCode"
          [options]="countries()!"
          [dropdownSelectedValueRef]="dropdownSelectedValueRef"
          (selected)="getPhoneCountryCode($event)"
        />

        <ng-template #dropdownSelectedValueRef let-dropdownValue>
          <span dir="ltr">({{ dropdownValue }})</span>

          <img
            src="https://flagcdn.com/{{ phoneCountryCode?.toLowerCase() }}.svg"
            alt="{{ phoneCountryCode }}'s flag"
            loading="lazy"
            width="40"
            height="30"
          />
        </ng-template>
      </div>

      @if (hasPermissionToCreate()) {
        <!-- password -->
        <div class="col-sm-6 col-lg-4">
          <app-input-text label="FIELDS.PASSWORD" formControlName="password" contentType="password" />
        </div>
      }
    </div>

    <hr />

    <!-- personal details -->
    <div class="row mt-4">
      <!-- isDisability -->
      <div class="col-sm-6 col-lg-4">
        <app-dropdown label="FIELDS.HAVE_DISABILITY" formControlName="isDisability" [options]="yesNoOptions" />
      </div>

      <!-- membershipCardPlanId -->
      @if (membershipCardPlans) {
        <div class="col-sm-6 col-lg-4">
          <app-dropdown label="FIELDS.SUBSCRIPTION_FOR" formControlName="membershipCardPlanId" [options]="membershipCardPlans()!" />
        </div>
      }

      <!-- disabilityAttachment -->
      @if (isDisabilityAttachmentEnabled) {
        <div class="col-sm-6 col-lg-4">
          <app-attachment
            class="d-block proof"
            label="FIELDS.DISABILITY_PROOF"
            formControlName="disabilityAttachment"
            type="imageDocument"
            [allowedTypes]="allowedTypes"
            [isEditMode]="!!itemId"
          />
        </div>
      }

      <!-- employmentType -->
      <div class="col-sm-6 col-lg-4">
        <app-dropdown
          label="FIELDS.JOB_STATUS"
          formControlName="employmentType"
          [options]="employmentTypes()!"
          (selected)="getEmploymentType($any($event))"
        />
      </div>

      @if (!readonly()) {
        <!-- dateOfBirth -->
        <ng-container formGroupName="user">
          <div class="col-sm-6 col-lg-4">
            <app-datepicker label="FIELDS.DATE_OF_BIRTH" formControlName="dateOfBirth" [maxDate]="birthDateMaxDate" />
          </div>
        </ng-container>
      }

      <!-- adding new fields in case the component is running in the admin page. -->
      <ng-content></ng-content>

      <ng-container formGroupName="user">
        <!-- countryId -->
        <div class="col-sm-6 col-lg-4">
          <app-dropdown label="FIELDS.COUNTRY" formControlName="countryId" [options]="countries()!" [readonly]="readonly()" />
        </div>

        <!-- gender -->
        <div class="col-sm-6 col-lg-4">
          <app-dropdown label="FIELDS.GENDER" formControlName="gender" [options]="genders()!" [readonly]="readonly()" />
        </div>
      </ng-container>

      <!-- residenceType -->
      <div class="col-sm-6 col-lg-4">
        <app-dropdown label="FIELDS.ARE_YOU" formControlName="residenceType" [options]="residenceTypes()!" />
      </div>
    </div>

    @if ((workPlaceDetails?.enabled || itemId) && isEmploymentTypeEmployee) {
      <!-- work place -->
      <div class="row row-gap-4 mt-4" formGroupName="workPlaceDetails">
        <div class="col-12">
          <h3 class="m-0 font-16 fw-bold text-black pe-4 pb-2 border-2 border-bottom d-flex w-max">
            {{ "FRIENDS_OF_OMAN_MUSEUM.WORK_PLACE" | translate }}
          </h3>
        </div>

        <!-- companyName -->
        <div class="col-sm-6 col-lg-4">
          <app-input-text label="FIELDS.ORGANIZATION_NAME" formControlName="companyName" />
        </div>

        <!-- address -->
        <div class="col-sm-6 col-lg-4">
          <app-input-text label="FIELDS.ORGANIZATION_ADDRESS" formControlName="address" />
        </div>

        <!-- jobTitle -->
        <div class="col-sm-6 col-lg-4">
          <app-input-text label="FIELDS.JOB_TITLE" formControlName="jobTitle" />
        </div>

        <!-- comments -->
        <div class="col-12">
          <app-input-text label="FIELDS.COMMENTS" formControlName="comments" inputType="textarea" />
        </div>
      </div>
    }

    <!-- Permanent Address -->
    <div class="row row-gap-4 mt-4" formGroupName="permanentAddressDetails">
      <div class="col-12">
        <h3 class="m-0 font-16 fw-bold text-black pe-4 pb-2 border-2 border-bottom d-flex w-max">
          {{ "FRIENDS_OF_OMAN_MUSEUM.PERMANENT_ADDRESS" | translate }}
        </h3>
      </div>

      <!-- zipCode -->
      <div class="col-sm-6 col-lg-4">
        <app-input-text label="FIELDS.ZIP_CODE" formControlName="zipCode" contentType="number" />
      </div>

      <!-- nationalId -->
      <div class="col-sm-6 col-lg-4">
        <app-input-text label="FIELDS.NATIONAL_ID" formControlName="nationalId" contentType="number" />
      </div>

      <!-- countryId -->
      <div class="col-md-6 col-lg-4">
        <app-dropdown
          label="FIELDS.COUNTRY"
          formControlName="countryId"
          [options]="countries()!"
          (selected)="getGovernorates($any($event))"
        />
      </div>

      @if (form.get("permanentAddressDetails")!.get("governorateId")!.enabled || itemId) {
        <!-- governorateId -->
        <div class="col-md-6 col-lg-4">
          <app-dropdown
            label="FIELDS.GOVERNORATE"
            formControlName="governorateId"
            [options]="governorates()!"
            (selected)="getStates($any($event))"
          />
        </div>
      }

      @if (form.get("permanentAddressDetails")!.get("stateId")!.enabled || itemId) {
        <!-- stateId -->
        <div class="col-md-6 col-lg-4">
          <app-dropdown label="FIELDS.STATE" formControlName="stateId" [options]="states()!" />
        </div>
      }
    </div>
  </div>
}
